import React from 'react';

import { IIconProps } from 'assets/icons/IconProps';

export const GeniusIcon = ({ width = 24, height = 24, fill = '#52575C' }: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.3048 19.3762C19.5233 19.1952 19.6446 18.9337 19.6446 18.6542V10.1913C19.6446 9.93537 19.4345 9.72522 19.1779 9.72522H12.4364C12.313 9.72701 12.1948 9.77531 12.1055 9.86047C12.0216 9.94924 11.9703 10.0658 11.9703 10.1913V13.1182C11.9713 13.2417 12.0197 13.3602 12.1055 13.449C12.1936 13.536 12.3126 13.5846 12.4364 13.5842H15.8564V16.604C14.6773 17.3822 13.2423 17.8386 11.6908 17.8386C7.69792 17.8386 4.45895 14.8098 4.45895 11.0811C4.45895 7.35391 7.69722 4.16627 11.6908 4.16627C13.5593 4.16627 15.2599 4.82793 16.5465 5.91822C16.6407 5.99869 16.7628 6.03881 16.8863 6.02989C16.9484 6.02524 17.009 6.00795 17.0642 5.97909C17.1194 5.95023 17.1682 5.9104 17.2074 5.86204C17.7085 5.26119 18.6892 4.07823 19.2412 3.41249L19.3506 3.28058C19.3899 3.23291 19.4192 3.17784 19.4368 3.11863C19.4544 3.05942 19.46 2.99728 19.4532 2.93588C19.448 2.87515 19.4304 2.81614 19.4016 2.76247C19.3727 2.70879 19.3332 2.66159 19.2854 2.62377C17.2449 0.987642 14.5885 0 11.6908 0C5.23714 0 0 5.05126 0 11.0818C0 17.1069 5.23714 22 11.6908 22C14.5934 22 17.2588 21.0124 19.3048 19.3762Z"
      fill={fill}
    />
  </svg>
);
